import { getMostRecentSubscription } from "@requests/subscriptions";
import { payloadActionGenerator } from "@utils/redux";
import { getCompanyMembers } from "src/requests/sponsors";

export const LOAD_SUBSCRIPTION = "LOAD_SUBSCRIPTION";
export const SET_SUBSCRIPTION = "SET_SUBSCRIPTION";
export const LOAD_PROPOSALS = "LOAD_PROPOSALS";
export const SET_REVIEWER_DASHBOARD_RFP = "SET_REVIEWER_DASHBOARD_RFP";
export const SET_PROPOSAL_DASHBOARD_RFP = "SET_PROPOSAL_DASHBOARD_RFP";
export const LOAD_USER_FOLLOW = "LOAD_USER_FOLLOW";
export const SET_USER_FOLLOW = "SET_USER_FOLLOW";
export const LOAD_COMPANY_MEMBERS = "LOAD_COMPANY_MEMBERS";
export const SET_COMPANY_MEMBERS = "SET_COMPANY_MEMBERS";
export const LOADING_MESSAGES = "LOADING_MESSAGES";
export const SET_MESSAGES = "SET_MESSAGES";
export const SET_VIEW_AS_COMPANY_SUPER_ADMIN = "SET_VIEW_AS_COMPANY_SUPER_ADMIN";

export const loadSubscription = payloadActionGenerator(LOAD_SUBSCRIPTION);
export const setSubscription = payloadActionGenerator(SET_SUBSCRIPTION);
export const loadProposals = payloadActionGenerator(LOAD_PROPOSALS);
export const setProposalDashboardRequest = payloadActionGenerator(SET_PROPOSAL_DASHBOARD_RFP);
export const loadUserFollow = payloadActionGenerator(LOAD_USER_FOLLOW);
export const setUserFollow = payloadActionGenerator(SET_USER_FOLLOW);
export const loadCompanyMembers = payloadActionGenerator(LOAD_COMPANY_MEMBERS);
export const setCompanyMembers = payloadActionGenerator(SET_COMPANY_MEMBERS);
export const loadingMessages = payloadActionGenerator(LOADING_MESSAGES);
export const setMessages = payloadActionGenerator(SET_MESSAGES);
export const setViewAsCompanySuperAdmin = payloadActionGenerator(SET_VIEW_AS_COMPANY_SUPER_ADMIN);

export const fetchSubscription = (companyIdentifier) => {
  return async (dispatch) => {
    const subscription = await getMostRecentSubscription(companyIdentifier);

    dispatch(setSubscription(subscription));

    return subscription;
  };
};

export const fetchAllCompanyMembers = (companyId) => {
  return async (dispatch) => {
    dispatch(loadCompanyMembers());

    const { sponsor_users } = await getCompanyMembers(companyId);
    dispatch(setCompanyMembers(sponsor_users));

    return sponsor_users;
  };
};
